/**
 * Shortens a TON address for display
 * @param address Full TON address (e.g., "UQAbcd...xyz")
 * @returns Shortened address (e.g., "UQAb...xy4z")
 */
export function shortenAddress(address, prefixLength = 4, suffixLength = 4) {
    if (!address || address.length <= prefixLength + suffixLength) {
        return address;
    }
    const prefix = address.slice(0, prefixLength);
    const suffix = address.slice(-suffixLength);
    return `${prefix}...${suffix}`;
}
/**
 * Validates a TON address format (basic check)
 * @param address Address to validate
 * @returns true if address appears valid
 */
export function isValidTonAddress(address) {
    // Basic validation: should start with EQ, UQ, or kQ and be base64-like
    if (!address)
        return false;
    const prefix = address.slice(0, 2);
    if (!['EQ', 'UQ', 'kQ'].includes(prefix))
        return false;
    // Should be 48 characters for user-friendly format
    if (address.length !== 48)
        return false;
    // Should only contain base64 characters
    const base64Regex = /^[A-Za-z0-9+/\-_]+$/;
    return base64Regex.test(address);
}
//# sourceMappingURL=address.js.map